<div class="row top-margin-15 nova-font-style manage-banking-info">
  <div class="col s12 m10 offset-m1 l8 offset-l2 xl6 offset-xl3">
    <h2>Banking Information</h2>
    <div class="top-margin-15" *ngIf="!showAddInfoText && bankDetails">
      <p class="headingrow"><span class="bold headingtext">Account Details</span></p>
      <form #bankInfoForm="ngForm" autocomplete="off">
        <div class="row">
          <div class="col s12 m12 l6 xl3">
            <span class="bold">Routing Number<span class="k-required" *ngIf="showForm">*</span>:</span>
          </div>
          <div class="col s12 m12 l6 xl4" *ngIf="!showForm">{{bankDetails.routingNumber}}</div>
          <div class="col s12 m12 l6 xl4" *ngIf="showForm">
            <input kendoTextBox minlength="1" maxlength="9" #routingNumber="ngModel" name="routingNumber"
              [(ngModel)]="bankDetails.routingNumber" required placeholder="XXXXXXXXX" ngDefaultControl
              id="routing-number" class="textbox-width" type="tel" (keyup)="onRnValueChange(bankInfoForm)"
              pattern="[0-9]*" />
            <div class="top-margin-1" *ngIf="showRoutingError">
              <span class="validationError">
                {{routingNumberError}}
              </span>
            </div>
          </div>
        </div>
        <div class="row bank-name">
          <div class="col s12 m12 l6 xl3">
            <span class="bold">Name:</span>
          </div>
          <div class="col s12 m12 l6 xl4" *ngIf="bankDetails.bankName">{{bankDetails.bankName}}</div>
        </div>
        <div class="row">
          <div class="col s12 m12 l6 xl3">
            <span class="bold">Account Number<span class="k-required" *ngIf="showForm">*</span>:</span>
          </div>
          <div class="col s12 m12 l6 xl4" *ngIf="!showForm">{{bankDetails.bankAcctNumber}}</div>
          <div class="col s12 m12 l6 xl4" *ngIf="showForm">
            <input kendoTextBox minlength="1" maxlength="17" #bankAccount="ngModel" name="bankAccount" id="bank-account"
              [disabled]="disableAccNumber" (keyup)="onValueChange()" [(ngModel)]="bankDetails.bankAcctNumber" required
              type="tel" placeholder="enter account number" ngDefaultControl class="textbox-width" onCopy="return false"
              onDrag="return false" onDrop="return false" onPaste="return false" [pattern]="accountPattern" />
            <div class="top-margin-1" *ngIf="isValidAccNo">
              <span class="validationError">
                {{invalidAccountNumber}}
              </span>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="showForm">
          <div class="col s12 m12 l6 xl3">
            <span class="bold">Confirm Account Number<span class="k-required">*</span>:</span>
          </div>
          <div class="col s12 m12 l6 xl4" *ngIf="showForm">
            <input kendoTextBox minlength="1" maxlength="17" #reBankAccount="ngModel" name="reBankAccount"
              [(ngModel)]="rebankAcc" required placeholder="re-enter account number" ngDefaultControl
              class="textbox-width" (keyup)="onValueChange()" onCopy="return false" onDrag="return false"
              onDrop="return false" onPaste="return false" type="tel" [pattern]="accountPattern"
              id="reenter-bank-account" />
            <div class="top-margin-1" *ngIf="showError">
              <span class="validationError">
                {{notMatchingText}}
              </span>
            </div>
          </div>
        </div>
        <div class="row align-right btns-div">
          <div *ngIf="!showForm">
            <div *ngIf="!isLoading && operators.Edit">
              <span class="k-icon k-i-edit link-icon"></span>
              <a class="clone-link" (click)="editBankInfo()" id="edit-btn">
                Edit
              </a>
            </div>
            <div *ngIf="isLoading">
              <span class="k-icon k-i-loading loading inner"></span>
            </div>
          </div>
          <div *ngIf="showForm">
            <div *ngIf="!isLoading">
              <span class="k-icon k-i-save link-icon"></span>
              <a class="clone-link" (click)="saveBank()" id="save-btn"
                [ngClass]="bankInfoForm.invalid || showError || showRoutingError ? 'disable-link' : ''">
                Save
              </a>
              <span class="k-icon k-i-cancel link-icon left-margin-5"></span>
              <a class="clone-link" (click)="cancelBank()" id="cancel-btn">
                Cancel
              </a>
            </div>
            <div *ngIf="isLoading">
              <span class="k-icon k-i-loading loading inner"></span>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div *ngIf="showAddInfoText && !bankDetails" class="add-info-div">
      {{addInfoText}}
      <div class="align-left top-padding-10" *ngIf="operators.Add">
        <span class="k-icon k-i-plus link-icon"></span>
        <a class="clone-link" (click)="addBankInfo()">
          Add account details
        </a>
      </div>
    </div>
  </div>
</div>
<app-notification-loading></app-notification-loading>
